module.exports = __webpack_public_path__ + "img/iqbal_ui_ux.9cc8263b.jpg";